export default "__VITE_ASSET__no9JY_yG__"